export class NewProjectData {
	public title: string;
	public message: string;
	public type: string;
	public nombre: string;
	public estado: number;
}